import React, { Component } from 'react';
import SimpleLayout from './SimpleLayout';
import '../css/style.css';
import '../components/Home.css';
import UserAdd from '../components/UserAdd';
import {  Row, Col } from 'react-bootstrap';

class LoginLayout extends Component {

    render(){
        return (
            <SimpleLayout>
            <Row   className=" justify-content-lg-center mt-5">
              <Col lg={6}>
                <UserAdd />
                </Col>
        </Row>
        
      </SimpleLayout>           
        );
    }

}

export default LoginLayout;